import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    devices: [],
    questionnaires: [],
    content: [],
};

const programTemplateListsSlice = createSlice({
    name: "programTemplateLists",
    initialState,
    reducers: {
        resetListState: (state) => {
            return initialState;
        },
        setListValue: (state, action) => {
            const { key, value } = action.payload;
            state[key] = value;
        },
        
    }
});

export const {
    resetListState,
    setListValue,
  } = programTemplateListsSlice.actions;
  
  export default programTemplateListsSlice.reducer;